(() => {
  const init = (header) => {
    header.querySelectorAll('[data-zj-mobile-accordion-trigger]').forEach((trigger) => {
      if (trigger.dataset.zjReady) return;
      trigger.dataset.zjReady = 'true';
      const key = trigger.dataset.zjMobileAccordionTrigger;
      const body = header.querySelector(`[data-zj-mobile-accordion-body="${key}"]`);
      if (!body) return;
      trigger.addEventListener('click', () => {
        const open = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!open));
        body.hidden = open;
      });
    });
  };
  const initMegaHover = (header) => {
    header.querySelectorAll('.zj-has-mega').forEach((li) => {
      if (li.dataset.zjMegaReady) return;
      li.dataset.zjMegaReady = 'true';
      let closeTimer = null;
      const open = () => { clearTimeout(closeTimer); li.classList.add('zj-mega-open'); };
      const scheduleClose = () => { closeTimer = setTimeout(() => li.classList.remove('zj-mega-open'), 250); };
      li.addEventListener('mouseenter', open);
      li.addEventListener('mouseleave', scheduleClose);
      li.addEventListener('focusin', open);
      li.addEventListener('focusout', scheduleClose);
    });
  };
  const initAll = (scope = document) => scope.querySelectorAll('.zj-site-header').forEach((header) => { init(header); initMegaHover(header); });
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
